import { Typography } from "@/components/atoms";
import { PaymentMethodsCard, ReceiptsCard } from "@/components/organisms/PaymentSettings";
import { useClientScope } from "./ClientScopeContext";

export const SettingsPayments = () => {
  const { accountId } = useClientScope();
  const isManaged = !!accountId;

  return (
    <div className="flex flex-col gap-4">
      <Typography variant="title" className="block">
        {isManaged ? "Payment Settings" : "Payments"}
      </Typography>
      <PaymentMethodsCard accountId={accountId} />
      <ReceiptsCard accountId={accountId} />
    </div>
  );
};
